import { CookieConsent, toast, Toaster } from '@acast/decibel';
import * as Sentry from '@sentry/browser';
import Config from 'app/config';
import { fetchNetworkPayees } from 'ducks/network';
import { fetchShows } from 'ducks/shows';
import { fetchUser, selectUserData } from 'ducks/user';
import T from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isUserAuthenticated } from 'services/authentication';
import { Container as ModalContainer } from 'services/modals';
import redirectToLogin from 'shared/helpers/redirect-to-login';
import { profilePropType } from '../../customPropTypes';
import intercom from '../../services/intercom';
import MainNavigation from './navigation/MainNavigation';

class App extends Component {
  static propTypes = {
    fetchUser: T.func,
    fetchShows: T.func,
    fetchNetworkPayees: T.func,
    children: T.node,
    location: T.object,
    hasCookieConsent: T.bool.isRequired,
    profile: profilePropType,
  };

  static contextTypes = {
    history: T.object,
  };

  state = {
    isLoading: true,
  };

  UNSAFE_componentWillMount() {
    this.goToLoginIfNeeded();
  }

  componentDidMount() {
    Promise.all([this.props.fetchUser(), this.props.fetchShows()])
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch(error => {
        toast.danger(`Error fetching user profile or user shows: ${error.message}`, {
          closable: true,
        });
        Sentry.captureException(error);
        this.setState({ isLoading: false });
      });

    this.props.fetchNetworkPayees().catch(error => {
      Sentry.captureException(error);
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const current = this.props.location.pathname;
    const next = nextProps.location.pathname;

    if (current !== next) {
      this.goToLoginIfNeeded(next);
    }
  }

  goToLoginIfNeeded = () => {
    if (!isUserAuthenticated()) {
      this.goToLogin();
    }
  };

  goToLogin() {
    redirectToLogin(window.location.pathname);
  }

  render() {
    if (!isUserAuthenticated()) {
      return null;
    }

    if (this.state.isLoading) {
      return null;
    }

    const { profile } = this.props;

    Sentry.configureScope(scope => {
      scope.setUser({
        id: profile.id,
      });
    });

    if (profile.user) {
      intercom.init({
        ...Config.get('INTERCOM'),
        user: {
          id: profile.user,
          email: profile.email,
        },
      });
    }

    return (
      <>
        <MainNavigation />
        <Toaster />
        <ModalContainer />
        {this.props.children}
      </>
    );
  }
}

const AppContainer = props => (
  <CookieConsent policyUrl={Config.get('COOKIE_POLICY_URL')} zIndex={2147483638}>
    {({ hasConsent }) => <App {...props} hasCookieConsent={hasConsent} />}
  </CookieConsent>
);

export default connect(
  state => ({ profile: selectUserData(state) }),
  {
    fetchUser,
    fetchShows,
    fetchNetworkPayees,
  }
)(AppContainer);
